import React, { useRef, useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

import "swiper/css";
import "swiper/css/pagination";
import "./styles.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Keyboard } from "swiper/modules";

import Course_Card from "./Course_Card";

const SkeletonCard = ({ cls }) => (
  <div className={`flex flex-col gap-3 ${cls}`}>
    <div className="h-44 w-full animate-pulse rounded-2xl bg-richblack-700" />
    <div className="h-4 w-3/4 animate-pulse rounded-lg bg-richblack-700" />
    <div className="h-3 w-1/2 animate-pulse rounded-lg bg-richblack-700" />
    <div className="h-3 w-1/3 animate-pulse rounded-lg bg-richblack-700" />
  </div>
);

const NavBtn = ({ onClick, disabled, children }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className="flex h-9 w-9 items-center justify-center rounded-full border border-richblack-600 bg-richblack-700 text-richblack-100 transition-all duration-150 hover:border-yellow-50/40 hover:bg-richblack-600 hover:text-yellow-50 disabled:cursor-not-allowed disabled:opacity-30"
  >
    {children}
  </button>
);

function Course_Slider({ Courses }) {
  const swiperRef   = useRef(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd,   setAtEnd]   = useState(false);

  const onSwiper = (s) => {
    swiperRef.current = s;
    setAtStart(s.isBeginning);
    setAtEnd(s.isEnd);
  };

  const onSlideChange = (s) => {
    setAtStart(s.isBeginning);
    setAtEnd(s.isEnd);
  };

  // undefined = still fetching → skeleton
  if (Courses === undefined) {
    return (
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        <SkeletonCard />
        <SkeletonCard cls="hidden sm:flex" />
        <SkeletonCard cls="hidden lg:flex" />
      </div>
    );
  }

  // [] = loaded but no courses
  if (Courses.length === 0) {
    return (
      <div className="flex h-44 items-center justify-center rounded-2xl border border-dashed border-richblack-600 bg-richblack-800">
        <p className="text-sm text-richblack-400">No courses available yet</p>
      </div>
    );
  }

  return (
    <div>
      {/* ── Custom nav row ── */}
      <div className="mb-4 flex items-center justify-end gap-2">
        <NavBtn onClick={() => swiperRef.current?.slidePrev()} disabled={atStart}>
          <FiChevronLeft className="text-base" />
        </NavBtn>
        <NavBtn onClick={() => swiperRef.current?.slideNext()} disabled={atEnd}>
          <FiChevronRight className="text-base" />
        </NavBtn>
      </div>

      <Swiper
        onSwiper={onSwiper}
        onSlideChange={onSlideChange}
        modules={[Pagination, Keyboard]}
        pagination={{ clickable: true }}
        keyboard
        loop={false}
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          640:  { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 24 },
        }}
        className="mySwiper !pb-10"
      >
        {Courses.map((course, i) => (
          <SwiperSlide key={i}>
            <Course_Card course={course} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Course_Slider;
